/* =================== Config / Debug =================== */
const DEBUG_OMETRIA = false; // set true while testing, false in production

/* ---------- small logger helpers ---------- */
function dbg(){ if (DEBUG_OMETRIA && window.console) console.log.apply(console, arguments); }
function grp(title, collapsed){
  if (!DEBUG_OMETRIA || !console) return function(){};
  const fn = collapsed && console.groupCollapsed ? 'groupCollapsed' : (console.group ? 'group' : null);
  if (fn) console[fn]('[zy-store] ' + title);
  return function(){ if (console.groupEnd) console.groupEnd(); };
}

/* ---------- constants & utils ---------- */
const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;

function parseDate(raw){
  if(!raw) return null;
  const s = String(raw).trim();

  // ISO / generally parseable
  const iso = new Date(s);
  if(!isNaN(iso)) return iso;

  // dd/mm/yyyy or mm/dd/yyyy [hh:mm[:ss]]
  const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
  if(!m) return null;

  const a  = parseInt(m[1],10);
  const b  = parseInt(m[2],10);
  const yy = m[3].length === 2 ? parseInt('20'+m[3],10) : parseInt(m[3],10);
  const hh = m[4] ? parseInt(m[4],10) : 0;
  const mm = m[5] ? parseInt(m[5],10) : 0;
  const ss = m[6] ? parseInt(m[6],10) : 0;

  let month, day;
  if (b > 12 && a <= 12) { month = a; day = b; }
  else if (a > 12 && b <= 12) { month = b; day = a; }
  else {
    const loc = (window.formLocale || 'pt-PT').toLowerCase();
    if (loc.indexOf('en') === 0) { month = a; day = b; }  // MM/DD/*
    else { month = b; day = a; }                           // DD/MM/*
  }

  const pad = n => String(n).padStart(2,'0');
  const norm = `${yy}-${pad(month)}-${pad(day)}T${pad(hh)}:${pad(mm)}:${pad(ss)}`;
  const dt = new Date(norm);
  return isNaN(dt) ? null : dt;
}

function formatDatePT(d){
  try {
    return d.toLocaleDateString('pt-PT',{day:'2-digit',month:'short',year:'numeric'});
  } catch(e){
    const pad = n => String(n).padStart(2,'0');
    return `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()}`;
  }
}

function e164(pt){
  const n = String(pt || '').replace(/\D+/g,'');
  return n.indexOf('351') === 0 ? `+${n}` : `+351${n}`;
}

function isIOS(){
  return /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

/* ---------- Ometria lookup (fetch with iOS XHR fallback) ---------- */
async function ometriaLookup(body){
  dbg('lookup →', body);
  if (isIOS()){
    // XHR fallback for older iPad webviews that can be fussy with fetch/CORS
    return new Promise((resolve,reject)=>{
      const xhr = new XMLHttpRequest();
      xhr.open('POST','https://zls-prod-ne-01-apim.zippylosan.com/ometria/checkuserexists',true);
      xhr.setRequestHeader('Content-Type','application/json');
      xhr.setRequestHeader('zls-key','fb97930859c84cdb95c6354b2487ce40');
      xhr.setRequestHeader('Accept','application/json');
      xhr.withCredentials = false;
      xhr.timeout = 15000;
      xhr.onreadystatechange = function(){
        if (xhr.readyState === 4){
          dbg('lookup ← status:', xhr.status);
          if (xhr.status === 200){
            try { const json = JSON.parse(xhr.responseText); dbg('lookup ← json:', json); resolve(json); }
            catch(e){ reject(e); }
          } else { reject(new Error('HTTP '+xhr.status)); }
        }
      };
      xhr.onerror = ()=>reject(new Error('Connection error'));
      xhr.ontimeout = ()=>reject(new Error('Request timeout'));
      xhr.send(JSON.stringify(body));
    });
  }

  const r = await fetch('https://zls-prod-ne-01-apim.zippylosan.com/ometria/checkuserexists',{
    method:'POST',
    headers:{
      'Content-Type':'application/json',
      'zls-key':'fb97930859c84cdb95c6354b2487ce40'
    },
    body:JSON.stringify(body)
  });
  dbg('lookup ← status:', r.status);
  const json = await r.json().catch(()=>null);
  dbg('lookup ← json:', json);
  if(!r.ok) throw new Error('Lookup falhou');
  return json;
}

/* ---------- Submit handler ---------- */
window.zyStoreProcessSubmit = async function (event){
  const end = grp('submit', true);
  event.preventDefault();

  const form = event.target;
  const msgDiv = document.getElementById('ometria-message');
  const locale = window.formLocale || 'pt-PT';

  const messages = {
    'pt-PT':{
      validating:'A validar...',
      emailExists:'Este e-mail já está subscrito.',
      birthlistExists:'Olá! Reparámos que já tem uma Lista de Nascimento ativa criada em {date}. Para criar uma nova, deverá primeiro fechar a que tem atualmente em curso. Não se esqueça de solicitar em loja os 10% do valor angariado com a mesma. Depois, já conseguirá criar a sua Lista de Nascimento nova. Até já!',
      error:'Erro no processamento. Tente novamente mais tarde.',
      iosWarning:'Nota: Falha ao validar no iPad. Verifique a ligação e tente novamente.'
    }
  };
  const msg = messages[locale] || messages['pt-PT'];

  if (!form.checkValidity()){
    form.reportValidity();
    end(); return false;
  }

  const submitBtn = form.querySelector('input[type=submit]');
  const originalText = submitBtn ? submitBtn.value : '';

  const phoneEl = document.getElementById('zysms');
  const cleave = phoneEl && phoneEl._cleave;
  const rawPhone = (cleave ? cleave.getRawValue() : (phoneEl ? phoneEl.value : '')).replace(/\D+/g,'');
  const email = (document.getElementById('subscriberemail')?.value || '').trim().toLowerCase();
  const phone = e164(rawPhone);
  const wantsBirthlist = !!document.getElementById('CurrentDate')?.checked;

  // quick phone sanity
  if (!/^\d{9,12}$/.test(rawPhone)){
    const parent = phoneEl.closest('.option');
    if (parent){
      const old = parent.querySelector('.error-message'); if (old) old.remove();
      phoneEl.classList.add('error');
      const err = document.createElement('span');
      err.className = 'error-message';
      err.textContent = 'Por favor, insira um número de telemóvel válido (+3519XXXXXXXX).';
      parent.appendChild(err);
    }
    end(); return false;
  }

  msgDiv.textContent = msg.validating;
  msgDiv.className = 'ometria-message loading';
  if (submitBtn){ submitBtn.value = msg.validating; submitBtn.disabled = true; }

  // Function to evaluate lookup results and decide to block/allow
  function evaluate(emailData, phoneData){
    dbg('emailData:', emailData);
    dbg('phoneData:', phoneData);

    // block duplicate only if existing signup is from stores program
    const emailExists = String(emailData && emailData.exists).toLowerCase() === 'true';
    const source = String(emailData && emailData.signup_source || '').toLowerCase();
    const isStoreSource = source.indexOf('subscricao-lojas-zippy') !== -1;

    if (!wantsBirthlist && emailExists && isStoreSource){
      msgDiv.textContent = msg.emailExists;
      msgDiv.className = 'ometria-message error';
      if (submitBtn){ submitBtn.value = originalText; submitBtn.disabled = false; }
      dbg('blocked: duplicate store subscription');
      return false;
    }

    if (wantsBirthlist){
      const candidates = [
        emailData && emailData.birthlist_signup_date,
        emailData && emailData.properties && emailData.properties.birthlist_signup_date,
        phoneData && phoneData.birthlist_signup_date,
        phoneData && phoneData.properties && phoneData.properties.birthlist_signup_date
      ];
      const dates = [];
      for (var i=0;i<candidates.length;i++){
        const d = parseDate(candidates[i]);
        if (d && !isNaN(d)) dates.push(d);
      }
      dbg('birthlist parsed dates:', dates.map(d=>d.toISOString()));
      if (dates.length){
        const last = new Date(Math.max.apply(null, dates.map(d=>d.getTime())));
        if (Date.now() - last.getTime() < ONE_YEAR){
          msgDiv.textContent = msg.birthlistExists.replace('{date}', formatDatePT(last));
          msgDiv.className = 'ometria-message error';
          if (submitBtn){ submitBtn.value = originalText; submitBtn.disabled = false; }
          dbg('blocked: birthlist < 1y');
          return false;
        }
      }
    }

    // success → optionally append hidden field if birthlist
    if (wantsBirthlist){
      const hiddenDateField = document.createElement('input');
      hiddenDateField.type = 'hidden';
      hiddenDateField.name = 'properties.birthlist_signup_date_actual';
      hiddenDateField.value = new Date().toISOString().slice(0,10);
      form.appendChild(hiddenDateField);
    }
    return true;
  }

  try{
    // iOS: try validation with a timeout safety
    if (isIOS()){
      const timeout = new Promise((_,rej)=>setTimeout(()=>rej(new Error('timeout')), 8000));
      const lookups = Promise.all([ometriaLookup({email}), ometriaLookup({phone})]);
      const [emailData, phoneData] = await Promise.race([lookups, timeout]);

      if (!evaluate(emailData, phoneData)){ end(); return false; }
    } else {
      const [emailData, phoneData] = await Promise.all([ometriaLookup({email}), ometriaLookup({phone})]);
      if (!evaluate(emailData, phoneData)){ end(); return false; }
    }

    // submit to Ometria
    form.action = 'https://api.ometria.com/forms/signup';
    form.onsubmit = null;
    dbg('submitting to Ometria…');
    HTMLFormElement.prototype.submit.call(form);
    end(); return true;

  } catch(e){
    console.error('[zy-store] validation error', e);
    msgDiv.textContent = isIOS() ? messages['pt-PT'].iosWarning : msg.error;
    msgDiv.className = 'ometria-message error';
    if (submitBtn){ submitBtn.value = originalText; submitBtn.disabled = false; }
    end(); return false;
  }
};

/* ---------- Extra fields toggle ---------- */
window.zyStoreToggleFields = function (){
  const extra = document.getElementById('extra-fields');
  const est   = document.getElementById('estimateddate');
  const gen   = document.getElementById('babygender');
  const reg   = document.getElementById('birthlistregulation');
  const store = document.getElementById('birthlist_creationstoreid');
  const cb    = document.getElementById('CurrentDate');
  if (!extra || !est || !gen || !reg || !store || !cb) return;

  const show = !!cb.checked;
  if (show){
    extra.classList.add('show');
    est.setAttribute('required','true');
    gen.setAttribute('required','true');
    reg.setAttribute('required','true');
    store.value = '1919';
  } else {
    extra.classList.remove('show');
    est.removeAttribute('required');
    gen.removeAttribute('required');
    reg.removeAttribute('required');
    store.value = '';
  }
};

/* ---------- DOM Ready: validation + cleave + bindings ---------- */
document.addEventListener('DOMContentLoaded', function (){
  window.formLocale = window.formLocale || document.documentElement.lang || 'pt-PT';

  const form = document.getElementById('zyFormStores');
  if (form && !form.getAttribute('onsubmit')){
    form.addEventListener('submit', window.zyStoreProcessSubmit);
  }

  const birthlistCheckbox = document.getElementById('CurrentDate');
  if (birthlistCheckbox){
    birthlistCheckbox.addEventListener('change', window.zyStoreToggleFields);
    // ensure initial state
    window.zyStoreToggleFields();
    // pre-fill date value
    const t = new Date();
    const pad = n => String(n).padStart(2,'0');
    birthlistCheckbox.value = `${t.getFullYear()}-${pad(t.getMonth()+1)}-${pad(t.getDate())}`;
  }

  // Cleave phone mask
  const phoneInput = document.getElementById('zysms');
  if (phoneInput && window.Cleave){
    new Cleave(phoneInput, {
      phone:true,
      phoneRegionCode:'PT',
      prefix:'+351',
      noImmediatePrefix:false // show +351 immediately for store staff convenience
    });
  }

  /* lightweight realtime validation */
  function isValidEmail(email){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }
  function validateField(field){
    if(!field) return true;
    const value = (field.value || '').trim();
    const isCheckbox = field.type === 'checkbox';
    const isEmail = field.type === 'email';
    const isSelect = field.tagName === 'SELECT';
    const parent = field.closest('.option');
    let errText = '';

    field.classList.remove('error');
    if (parent){
      const old = parent.querySelector('.error-message');
      if (old) old.remove();
    }

    let required = field.hasAttribute('required');
    // ignore hidden birthlist fields when the panel is closed
    const extra = document.getElementById('extra-fields');
    if (extra && extra.contains(field) && !extra.classList.contains('show')) required = false;

    if (required){
      if ((isCheckbox && !field.checked) || (!isCheckbox && !isSelect && !value) || (isSelect && !value)){
        errText = 'Campo obrigatório.';
      } else if (isEmail && value && !isValidEmail(value)){
        errText = 'Por favor, insira um endereço de e-mail válido.';
      } else if (field.id === 'zysms' && value){
        const numbersOnly = value.replace(/\s/g,'');
        if (!/^\+351\d{9}$/.test(numbersOnly)) errText = 'Por favor, insira um número de telemóvel válido (+3519XXXXXXXX).';
      }
    }

    if (errText && parent){
      field.classList.add('error');
      const span = document.createElement('span');
      span.className = 'error-message';
      span.textContent = errText;
      parent.appendChild(span);
      return false;
    }
    return true;
  }

  if (form){
    const fields = form.querySelectorAll('#subscriberstore,#subscribername,#subscriberemail,#zysms,#subscriberconditions,#babygender,#estimateddate,#birthlistregulation');
    fields.forEach(f=>{
      const evt = (f.tagName==='SELECT' || f.type==='checkbox' || f.type==='date') ? 'change' : 'input';
      f.addEventListener(evt, ()=>validateField(f));
      const blurEvt = (f.tagName==='SELECT' || f.type==='checkbox' || f.type==='date') ? 'change' : 'blur';
      f.addEventListener(blurEvt, ()=>validateField(f));
    });

    form.addEventListener('submit', function(e){
      let ok = true;
      const requiredNow = form.querySelectorAll('input[required], select[required]');
      requiredNow.forEach(f=>{ if(!validateField(f)) ok=false; });
      if(!ok) e.preventDefault();
    });
  }
});
